/**
 * How many columns one report may show. A LEAF MODULE, and that is the whole reason it exists.
 *
 * This lived on ReportResultEnterpriseComponent, and the metadata file imported it from there --
 * which closed a cycle: the metadata imports the component, the component imports
 * EnterpriseComponent, that imports EnterpriseComponentMetadataClassFactory, and the factory imports
 * the metadata. Webpack resolved it to `Cannot access '__WEBPACK_DEFAULT_EXPORT__' before
 * initialization` and the app rendered a BLANK PAGE on every route, not merely on the report
 * builder.
 *
 * NEITHER tsc NOR THE PRODUCTION BUILD SAW IT. Both were clean. A cycle is only a problem at
 * evaluation time, so the only thing that finds it is loading the page -- which is the argument for
 * doing that before believing a green build.
 *
 * So the constant lives somewhere that imports NOTHING. Anything else shared between a component and
 * its metadata belongs here too.
 *
 * TWELVE, and the cap is real rather than arbitrary-looking: a grid wider than that is a table
 * nobody reads across, and a report wanting forty columns is an export. The service caps rows; this
 * caps columns; both are stated rather than discovered.
 */
export const MAX_COLUMNS = 12;
